<template>
  <transition name="fade">
    <div v-if="showDetail" class="h-100">
      <div class="d-flex flex-column h-100 pb-4">

        <!-- HEADER -->
        <div class="d-flex align-start justify-space-between mb-4">
          <div>
            <div class="d-flex align-center mb-1">
              <h2 class="text-h5 font-weight-bold grey--text text--darken-3 mb-0 mr-3">
                #{{ selectedItem.Folio }}
              </h2>
              <v-chip color="primary" outlined small class="font-weight-bold" style="border-radius: 8px;">
                {{ selectedItem.TypeRes }}
              </v-chip>
            </div>
            <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2">
              {{ $pgsHelper.getNombreCampo() }}
            </div>
            <div class="text-caption grey--text text--darken-1">
              {{ $pgsHelper.getDireccionCampo() }}
            </div>
          </div>

          <div class="text-right">
            <div class="d-inline-flex align-center bg-blue-lighten-5 blue--text text--darken-3 px-3 py-2 rounded-lg">
              <v-icon color="blue darken-2" class="mr-2" small>mdi-calendar-clock</v-icon>
              <div class="font-weight-bold">
                {{ dateInfo(selectedItem.RF.FI).format("DD-MM-YYYY | HH:mm") }}
              </div>
            </div>
          </div>
        </div>

        <v-alert v-if="selectedItem.Transportacion" dense text color="amber darken-3" icon="mdi-bus"
          class="mb-4 rounded-lg">
          <span class="font-weight-medium">Transportación:</span> {{ selectedItem.Transportacion.Confirmacion }}
        </v-alert>

        <!-- TABS -->
        <v-tabs v-model="tabSelected" background-color="transparent" color="primary" class="mb-4 border-bottom">
          <v-tab class="text-none font-weight-bold">Resumen</v-tab>
          <v-tab class="text-none font-weight-bold">Detalle Jugadores</v-tab>
        </v-tabs>

        <!-- TAB CONTENT -->
        <div class="flex-grow-1 overflow-y-auto pr-2 custom-scrollbar">

          <!-- TAB 0: RESUMEN -->
          <div v-if="tabSelected === 0" class="pt-2">
            <h3 class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-3">Información General</h3>

            <v-row class="mb-6">
              <v-col cols="6">
                <div class="info-block pa-3 rounded-lg bg-white border">
                  <div class="text-caption grey--text text--darken-1 font-weight-bold text-uppercase mb-1">Cliente</div>
                  <div class="text-body-2 font-weight-medium text-truncate">{{ selectedItem.Cliente.Nombre }}</div>
                  <div class="text-caption grey--text">{{ selectedItem.Cliente.Correo }}</div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="info-block pa-3 rounded-lg bg-white border h-100 d-flex flex-column justify-center">
                  <div class="text-caption grey--text text--darken-1 font-weight-bold text-uppercase mb-1">Jugadores
                  </div>
                  <div class="text-h6 font-weight-bold primary--text">{{ realPlayers }} <span
                      class="text-caption grey--text font-weight-regular">personas</span></div>
                </div>
              </v-col>
            </v-row>

            <v-alert border="left" colored-border color="primary" elevation="0" class="bg-white border rounded-lg">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-caption grey--text font-weight-bold text-uppercase">Total Reservación</div>
                  <div class="text-caption grey--text">Folio: {{ selectedItem.Folio }}</div>
                </div>
                <div class="text-right">
                  <div class="text-h5 font-weight-bold primary--text">
                    {{ $pgsHelper.formatNumber(selectedItem.Totales.USD) }} USD
                  </div>
                  <div class="text-subtitle-2 grey--text">
                    {{ $pgsHelper.formatNumber(selectedItem.Totales.MXN) }} MXN
                  </div>
                </div>
              </div>
            </v-alert>
          </div>

          <!-- TAB 1: DETALLE -->
          <div v-if="tabSelected === 1" class="pt-2">

            <div class="d-flex align-center mb-3">
              <v-icon color="grey darken-1" class="mr-2">mdi-account-group</v-icon>
              <h3 class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-0">Jugadores</h3>
            </div>

            <v-card outlined class="rounded-lg mb-6 overflow-hidden">
              <v-simple-table dense>
                <thead class="bg-grey-lighten-4">
                  <tr>
                    <th class="text-left font-weight-bold">Jugador</th>
                    <th class="text-left font-weight-bold">Email</th>
                    <th class="text-left font-weight-bold">Detalles de Cuenta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(player, index) in players" :key="index"
                    :class="{ 'bg-red-lighten-5': player.Estatus === 'C' }">
                    <td class="font-weight-medium" :class="{ 'error--text': player.Estatus === 'C' }">
                      {{ player.Nombre }}
                      <v-chip v-if="player.Estatus === 'C'" color="error" x-small label class="ml-2">Cancelado</v-chip>
                    </td>
                    <td class="text-caption">{{ player.Correo }}</td>
                    <td>
                      <div v-for="(cuenta, idx) in player.Cuenta" :key="idx" class="text-caption"
                        :class="{ 'error--text': player.Estatus === 'C' }">
                        • {{ cuenta.Nombre }}: <span class="font-weight-medium">{{ cuenta.Pco }} {{ cuenta.Mnd }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>

            <div v-if="CartRiders && CartRiders.length > 0">
              <div class="d-flex align-center mb-3">
                <v-icon color="grey darken-1" class="mr-2">mdi-golf-cart</v-icon>
                <h3 class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-0">Extras</h3>
              </div>
              <v-card outlined class="rounded-lg mb-6 overflow-hidden">
                <v-simple-table dense>
                  <thead class="bg-grey-lighten-4">
                    <tr>
                      <th class="text-left font-weight-bold">Nombre</th>
                      <th class="text-right font-weight-bold">Precio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cartRider, index) in CartRiders" :key="index">
                      <td class="font-weight-medium text-caption">{{ cartRider.NombreRider }}</td>
                      <td class="text-right font-weight-bold text-caption">{{ cartRider.Pco }} {{ cartRider.Mnd }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </div>

            <div v-if="selectedItem.Notas">
              <div class="d-flex align-center mb-2">
                <v-icon color="grey darken-1" class="mr-2">mdi-note-text-outline</v-icon>
                <h3 class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-0">Notas</h3>
              </div>
              <v-card outlined class="rounded-lg pa-3 bg-amber-lighten-5">
                <p class="mb-0 text-caption grey--text text--darken-2 font-italic">{{ selectedItem.Notas }}</p>
              </v-card>
            </div>

          </div>
        </div>
      </div>

      <v-overlay v-if="showLoader" absolute>
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="mt-4 font-weight-bold">Guardando...</div>
      </v-overlay>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.h-100 {
  height: 100%;
}

.border {
  border: 1px solid #e2e8f0 !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.info-block {
  min-height: 80px;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}

/* Utilitarios extra si vuetify no los carga bien en esta version */
.bg-white {
  background-color: white !important;
}

.bg-grey-lighten-4 {
  background-color: #f8fafc !important;
}

.bg-blue-lighten-5 {
  background-color: #eff6ff !important;
}

.bg-amber-lighten-5 {
  background-color: #fffbeb !important;
}

.bg-red-lighten-5 {
  background-color: #fef2f2 !important;
}
</style>

<script>
import moment from "moment";
export default {
  name: "detailReservationCard",
  components: {},
  props: ["showDetail", "selectedItem", "status"],
  data() {
    return {
      showLoader: false,
      showStatus: true,
      tabSelected: 0,
    };
  },
  methods: {
    async onChangeStatus(newData) {
      let oldData = this.selectedItem.Estatus;
      this.selectedItem.Estatus = newData;
      this.$swal({
        title: "Cambiar datos de la reservación",
        text: "El estatus de la reservación se modificara ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cambiar Estatus",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          this.showLoader = true;
          //var changeStatus = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-cambiarStatus');
          await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Reservas-cambiarStatus", {
              Estatus: this.selectedItem.Estatus,
              reservaId: this.selectedItem.id,
              Departamento: this.selectedItem.Departamento,
            })
            .then((result) => {
              if (result.data.ok == true) {
                this.$swal(
                  "Guardado",
                  "Cambios guardados con éxito",
                  "success"
                );
                this.showLoader = false;
              }
            });
        } else {
          this.selectedItem.Estatus = oldData;
        }
      });
    },
    openChat() {
      //this.selectedItem.Transportacion.Confirmacion
      window.open("/chat/" + this.selectedItem.Transportacion.Confirmacion);
    },
    emitToogleModal() {
      this.$emit("openModal", true);
    },
    dateInfo(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD_HH:mm:ss");
      } else {
        return moment();
      }
    },
  },
  computed: {
    realPlayers() {
      return this.players.filter((p) => p.Estatus !== "C").length;
    },

    CartRiders() {
      let extraRider = [];
      //players.push({Nombre:this.selectedItem.Cliente.Nombre,Correo:this.selectedItem.Cliente.Correo});

      this.selectedItem.Cuentas.forEach((element, index) => {
        if (element.indexCuenta == "Extra") {
          element.Catalogo.forEach((catalogo, index) => {
            if (catalogo.ExtraParams.ERExtraData) {
              catalogo.ExtraParams.ERExtraData.forEach((exr, index) => {
                let extraR = {
                  NombreRider: exr.N,
                  index: index,

                  /*Precio:catalogo.Pco,
                        Moneda:catalogo.Mnd,*/
                  E: exr.E,
                  ...catalogo,
                };

                extraR.ExtraParams = {
                  ...extraR.ExtraParams,
                  ERExtraData: [
                    {
                      I: exr.I,
                      N: exr.N,
                      E: exr.E,
                    },
                  ],
                };

                extraRider.push(extraR);
              });
            }
          });
        }
      });

      return extraRider;
    },
    players() {
      let players = [];
      //players.push({Nombre:this.selectedItem.Cliente.Nombre,Correo:this.selectedItem.Cliente.Correo});

      this.selectedItem.Cuentas.forEach((element, index) => {
        if (element.indexCuenta != "Extra") {
          players.push({
            Nombre: element.Nombre,
            Correo: element.Correo,
            Cuenta: element.Catalogo,
            Estatus: element.Estatus,
          });
        }
      });
      return players;
    },
  },
  watch: {},
  beforeMount: function () {
    if (this.$route.params.user.tokenResult.claims.Type == "Mayorista") {
      this.showStatus = false;
    }
  },
  mounted() { },
};
</script>

<style scoped>
.colorRed {
  color: red;
}
</style>
